export enum MediaFamilyType {
    DEFAULT = 'DEFAULT',
    OTP_SMS = 'OTP_SMS',
    OTP_CLIENT = 'OTP_CLIENT',
    OTP_CB = 'OTP_CB',
    VEHICLE_MAC = 'VEHICLE_MAC',
}
